import apiClient from '@/utils/api-client'
import {StatusResponse} from "@/model/models";
import {clearAllSessionCaches} from "@/utils/session-cache";

class CacheService {

    public clearUsersCache() {
        return new Promise<StatusResponse>((resolve, reject) => {
            apiClient.get('/api/v1/cache/clear-users')
                .then((res) => {
                    if (res.status === 200 && res.data !== null) {
                        resolve(new StatusResponse(res.data.code, res.data.userId, res.data.message, res.data.timeStamp))
                    } else {
                        reject(new Error(res.data.message))
                    }
                })
                .catch((error) => {
                    reject(false);
                });
        });
    }

    public clearStaticCache() {
        return new Promise<StatusResponse>((resolve, reject) => {
            apiClient.get('/api/v1/cache/clear-static')
                .then((res) => {
                    clearAllSessionCaches()
                    if (res.status === 200 && res.data !== null) {
                        resolve(new StatusResponse(res.data.code, res.data.userId, res.data.message, res.data.timeStamp))
                    } else {
                        reject(new Error(res.data.message))
                    }
                })
                .catch((error) => {
                    reject(false);
                });
        });
    }
}

export default new CacheService ()